// Makes any link to the Square ordering site open in a new tab,
// so customers don't lose an in-progress Shopify cart when they
// navigate over to place a local pickup/delivery order.
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[href*="square.site"]').forEach(function (link) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
    });
});